import { Search, X } from "lucide-react";
import { Input } from "@/components/ui/input.tsx";
import { cn } from "@/lib/utils";

interface SearchBarProps {
  placeholder: string;
  searchText: string;
  setSearchText: (e: string) => void;
  className?: string;
  containerClassName?: string;
}
const SearchBar: React.FC<SearchBarProps> = ({
  placeholder,
  searchText,
  setSearchText,
  className = "",
  containerClassName = "",
}) => {
  return (
    <div className={cn("relative w-50 flex items-center", containerClassName)}>
      <Search
        size={15}
        className="absolute left-2 top-1/2 transform -translate-y-1/2 text-secondary-icon"
      />
      <Input
        type="text"
        value={searchText}
        onChange={(e) => setSearchText(e.target.value)}
        placeholder={placeholder}
        className={cn(
          "border border-ring rounded pl-8 bg-primary dark:bg-primary pr-6",
          className,
        )}
      />
      {!!searchText.length && (
        <X
          className="absolute right-2 w-4 h-4 cursor-pointer"
          onClick={() => {
            setSearchText("");
          }}
        />
      )}
    </div>
  );
};

export default SearchBar;
